//@flow

import type {DisplayPricesOption, ProductPack, ProductPackPrices} from "./productPricingTypes";
import {toHTMLElement, isMaxUser} from "../utils";

const getProductPackPrices = (productTile: HTMLElement, pack: ProductPack, getCmp: boolean): ProductPackPrices => {

  const priceDataElementPrefix = `data-${pack === '1' ? 'pack1' : 'pack2'}-${getCmp ? 'cmp' : 'myprice'}`;

  return {
    gstInclusive: parseFloat(productTile.getAttribute(`${priceDataElementPrefix}-inc-gst`)),
    gstExclusive: parseFloat(productTile.getAttribute(`${priceDataElementPrefix}-exc-gst`))
  }
};

const getPriceOnQuantity = (price: number, quantity: number) : string =>
  (price * quantity).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });

const updateAndDisplayPriceDiv = (productTile : HTMLElement, quantity: number, pack: ProductPack, showGstInclusive: boolean, updateCmp: boolean) => {
  const priceDiv = updateCmp ? ".product-tile__price--cmp" : ".product-tile__price--my-price";

  const prices: ProductPackPrices = getProductPackPrices(productTile, pack, updateCmp);

  showElement(toHTMLElement(productTile.querySelector(priceDiv)));

  if ((prices.gstInclusive >= 0) && (prices.gstExclusive >= 0)) {
    if (showGstInclusive) {
      toHTMLElement(productTile.querySelector(`${priceDiv} .product-tile__price-val`)).innerHTML = getPriceOnQuantity(prices.gstInclusive, quantity);
      toHTMLElement(productTile.querySelector(`${priceDiv} .product-tile__price-suffx`)).innerHTML = "(inc.gst)";
    } else {
      toHTMLElement(productTile.querySelector(`${priceDiv} .product-tile__price-val`)).innerHTML = getPriceOnQuantity(prices.gstExclusive, quantity);
      toHTMLElement(productTile.querySelector(`${priceDiv} .product-tile__price-suffx`)).innerHTML = "(exc.gst)";
    }
  } else {
    hideElement(toHTMLElement(productTile.querySelector(priceDiv)));
  }
};

const hideElement = (ele: HTMLElement) =>  ele.classList && ele.classList.add("hidden");

const showElement = (ele: HTMLElement) =>  ele.classList && ele.classList.remove("hidden");

const hidePriceDivs = (productTile: HTMLElement) => {
  hideElement(toHTMLElement(productTile.querySelector(".product-tile__price--cmp")));
  hideElement(toHTMLElement(productTile.querySelector(".product-tile__price--my-price")));
};

export const updateDisplayedPrices = (win: WindowProxy, productCode: string, quantity: number, pack: ProductPack, showGstInclusive: boolean, showPricesOption: DisplayPricesOption) => {
  const productTile : HTMLElement = toHTMLElement(win.document.querySelector(`.product-tile[data-product-code="${productCode}"]`));

  hidePriceDivs(productTile);

  if (showPricesOption === 'myprice_and_cmp' || showPricesOption === 'cmp') {
    updateAndDisplayPriceDiv(productTile, quantity, pack, showGstInclusive, true);
  }

  if (showPricesOption === 'myprice_and_cmp' || showPricesOption === 'myprice') {
    updateAndDisplayPriceDiv(productTile, quantity, pack, showGstInclusive, false);
  }

};

const getCustomerPrice = (productTile : HTMLElement, pack: ProductPack) => {
    return parseFloat(productTile.getAttribute(`data-${pack === '1' ? 'pack1' : 'pack2'}-myprice-inc-gst`));
};

export const getCmpPrice = (productTile : HTMLElement, pack: ProductPack) => {
    return parseFloat(productTile.getAttribute(`data-${pack === '1' ? 'pack1' : 'pack2'}-cmp-inc-gst`));
};

export const getPrice = (productTile : HTMLElement, pack: ProductPack) => {
    return isMaxUser(window) ? (getCustomerPrice(productTile, pack) >= 0 || getCmpPrice(productTile, pack) >= 0) :
        (getCmpPrice(productTile, pack) >= 0);
};

export const isValidPrice = (productTile : HTMLElement, pack: ProductPack) => {
    return getPrice(productTile, pack) ? true : false;
};


// WEBPACK FOOTER //
// ./javascript/product-search-page/product-pricing/updateDisplayedPrices.js